// googleSheetService

import { appConfig } from "../../config/appConfig";

export async function sendToGoogleSheet(payload) {
  try {
    const scriptUrl = appConfig.googleSheetScriptUrl;

    if (!scriptUrl) {
      console.warn("Google Sheet Script URL is missing.");

      return {
        success: false,
        message: "Google Sheet Script URL is missing.",
      };
    }

    await fetch(scriptUrl, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    return {
      success: true,
      message: "Data sent to Google Sheet.",
    };
  } catch (error) {
    console.error("Google Sheet submission error:", error);

    return {
      success: false,
      error,
      message: "Failed to send data to Google Sheet.",
    };
  }
}

export async function sendRegistrationToGoogleSheet(registrationData) {
  return sendToGoogleSheet({
    action: "registration",
    ...registrationData,
  });
}

export async function sendCheckInToGoogleSheet(checkInData) {
  return sendToGoogleSheet({
    action: "check_in",
    ...checkInData,
  });
}